var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowShortRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53222 4.45328C5.67282 4.59393 5.75181 4.78466 5.75181 4.98353C5.75181 5.18241 5.67282 5.37314 5.53222 5.51378L1.28947 9.75653C1.22028 9.82817 1.13752 9.8853 1.04602 9.92461C0.954517 9.96392 0.856102 9.98461 0.756517 9.98547C0.656933 9.98634 0.558173 9.96736 0.466001 9.92965C0.373829 9.89194 0.290089 9.83625 0.21967 9.76583C0.14925 9.69541 0.0935604 9.61167 0.0558497 9.5195C0.0181391 9.42733 -0.000837044 9.32857 2.83178e-05 9.22898C0.00089368 9.1294 0.0215834 9.03098 0.0608901 8.93948C0.100197 8.84798 0.157333 8.76522 0.228966 8.69604L3.94147 4.98353L0.228966 1.27103C0.0923474 1.12958 0.0167516 0.94013 0.0184605 0.743483C0.0201693 0.546835 0.0990458 0.358726 0.238102 0.21967C0.377158 0.0806137 0.565268 0.00173717 0.761915 2.8352e-05C0.958563 -0.00168046 1.14801 0.0739153 1.28947 0.210534L5.53222 4.45328Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShortRight);
export default __webpack_public_path__ + "static/media/arrow_short_right.5bd20d37b6b9c7952f89177f759eb303.svg";
export { ForwardRef as ReactComponent };